export const themeOverrides = {
  components: {
    card: {
      'border-color': '#B8B8B8',
    },
    'form-control': {
      'border-radius': 0,
    },
  },
};
